export enum VideoContentType {
  Music = 'Music',
  NonMusic = 'NonMusic',
}
